import type { RouteDefinition } from "./route-definition.ts";

export const marketingRoutes = {
  home: {
    path: "/",
    scope: "static",
    bucket: "marketing",
    entry: "nav",
    disposition: "page",
  },
  mission: {
    path: "/mission",
    scope: "static",
    bucket: "marketing",
    entry: "nav",
    disposition: "page",
  },
  team: {
    path: "/team",
    scope: "static",
    bucket: "marketing",
    entry: "nav",
    disposition: "page",
  },
  media: {
    path: "/media",
    scope: "static",
    bucket: "marketing",
    entry: "nav",
    disposition: "page",
  },
  events: {
    path: "/events",
    scope: "static",
    bucket: "marketing",
    entry: "nav",
    disposition: "page",
  },
  contact: {
    path: "/contact",
    scope: "static",
    bucket: "marketing",
    entry: "nav",
    disposition: "page",
  },
  privacy: {
    path: "/privacy",
    scope: "static",
    bucket: "marketing",
    entry: "nav",
    disposition: "page",
  },
  terms: {
    path: "/terms",
    scope: "static",
    bucket: "marketing",
    entry: "nav",
    disposition: "page",
  },
  blog: {
    path: "/blog",
    scope: "static",
    bucket: "marketing",
    entry: "nav",
    disposition: "page",
  },
  jobs: {
    path: "/jobs",
    scope: "static",
    bucket: "marketing",
    entry: "nav",
    disposition: "page",
  },
  blogPost: {
    path: "/blog/:slug",
    scope: "static",
    bucket: "marketing",
    entry: "parent",
    disposition: "page",
  },
  recyclopedia: {
    path: "/recyclopedia/*slug?",
    scope: "static",
    bucket: "marketing",
    entry: "direct",
    disposition: "retired",
  },
  opengraphImage: {
    path: "/opengraph-image",
    scope: "static",
    bucket: "marketing",
    entry: "direct",
    disposition: "document",
  },
  twitterImage: {
    path: "/twitter-image",
    scope: "static",
    bucket: "marketing",
    entry: "direct",
    disposition: "document",
  },
} as const satisfies Record<string, RouteDefinition>;
